module.exports = __webpack_public_path__ + "static/media/resource-6.67d00c6c.jpg";